import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import { getpawnShopObjMap, pawnShopObjCanFixCountAry, pawnShopObjPigmentCountAry } from "../../../gameFrameScript/pawnShopGame/pawnShop/config/pawnShopConfig";
import { pawnShopBackpackObjI, pawnShopGameDataI,pawnShopGameObjI, pawnShopObjQualityE } from "../../../gameFrameScript/pawnShopGame/pawnShop/const/pawnShopConst";
import NormalGameManager from "./NormalGameManager";

export default class pawnShopManager{
    gameManger:NormalGameManager = null;

    constructor(manager:NormalGameManager){
        this.gameManger = manager;
        this.loadData();
    }

    private _save_data_key:string = "pawn-shop-save-data-key";
    private _data:pawnShopGameDataI = {
        backpack: {}
    }

    loadData(){
        let dataStr: string = O1HD.getServices().localStorageSrv.getStorage(this._save_data_key)|| JSON.stringify(this._data);
        let data = JSON.parse(dataStr);
        this.setData(data, false);
    }

    setData(data:pawnShopGameDataI,isPlus:boolean){
        for (let key in data) {
            let k = data[key];
            if (k != null) {
                if (k instanceof Array) {
                    if (isPlus) {
                        this._data[key] = this._data[key].concat(k);
                    } else {
                        this._data[key] = [].concat(k);
                    }
                } else {
                    if (isPlus) {
                        this._data[key] += k;
                    } else {
                        this._data[key] = k;
                    }
                }
            }
        }
        this.writeData();
    }
    //获取游戏数据
    getData() {
        return this._data;
    }
    //写入游戏数据
    writeData() {
        O1HD.getServices().localStorageSrv.setStorage(this._save_data_key, JSON.stringify(this._data));
    }
    
    getOneObj(objId:string,index:number){
        let obj = this.getData().backpack[objId][index];
        return obj;
    }

    //往背包中添加一个物品
    addOneObj(obj:pawnShopGameObjI,buyPrice:number = 0){
        let objAry = this.getData().backpack[obj.id];
        if(!objAry){
            this.getData().backpack[obj.id] = [];
        }
        let quality = obj.quality;
        let canFixCount = Math.floor(data_control.getRandNumberOfArrayTwo(pawnShopObjCanFixCountAry[quality]));
        let newObj:pawnShopBackpackObjI = {
            id: obj.id,
            buyPrice: buyPrice,
            buyTime: this.gameManger.getCurrentDay(),
            canFixCount: canFixCount,
            fixCount: 0
        }
        this.getData().backpack[obj.id].push(newObj);
        NormalGameManager._instance.onPushGoods(obj.bindBackId);
        this.writeData();
        return newObj;
    }

    //往背包中移除一个物品
    removeOneObj(objId:string,index:number){
        let obj = this.getOneObj(objId,index);
        if(!obj){
            console.log("移除背包中没有的物品");
            return;
        }
        let objConfig = getpawnShopObjMap()[obj.id];
        this.getData().backpack[objId].splice(index,1);
        this.gameManger.onOutGoods(objConfig.bindBackId);
        this.writeData();
    }

    //分解一个物品
    resolveOneObj(obj:pawnShopBackpackObjI,backPackAutoRemove:boolean = false){
        let objConfig = getpawnShopObjMap()[obj.id];
        let resolveCount = this.getOneObjResolveCount(obj.id);
        let isTrue = this.spliceOneObj(obj);
        if(isTrue){
            if(backPackAutoRemove){
                this.gameManger.onOutGoods(objConfig.bindBackId,1);
            }
            this.gameManger.onPushGoods(10000,resolveCount);
            O1HD.getModules().uiControlModule.showMessageBox(`分解获取${resolveCount}碎片`);
        }
    }

    getOneObjResolveCount(id:string){
        let objConfig = getpawnShopObjMap()[id];
        let resolveCount:number = pawnShopObjPigmentCountAry[objConfig.quality];
        return resolveCount;
    }

    getLessObj(objId:string){
        let backpack = this.getData().backpack;
        let ary = backpack[objId]?.concat();
        if(!ary || ary.length < 1){
            return null;
        }
        ary.sort((aObj:pawnShopBackpackObjI,bObj:pawnShopBackpackObjI)=>{
            return aObj.fixCount - bObj.fixCount;
        });
        let aObj = ary[0];
        return aObj;
    }

    spliceOneObj(obj:pawnShopBackpackObjI){
        if (!obj) {
            return false;
        }
        let objAry = this.getData().backpack[obj.id];
        if (!objAry || objAry.length <= 0) {
            return false;
        }
        let index:number = objAry.findIndex((o:pawnShopBackpackObjI)=>{return JSON.stringify(obj) == JSON.stringify(o)});
        if(index > -1){
            this.getData().backpack[obj.id].splice(index,1);
            this.writeData();
            return true;
        }
        return false;
    }

    resolveLessObj(objId:string){
        let aObj = this.getLessObj(objId);
        if(!aObj) return 0;
        this.resolveOneObj(aObj);
        return this.getOneObjResolveCount(objId);
    }

    addOneFixCount(obj:pawnShopBackpackObjI,index:number){
        let id = obj.id;
        this.getData().backpack[id][index].fixCount ++;
        this.writeData();
        return this.getData().backpack[id][index];
    }

    //判断是否可以进行出售
    checkCanSell(){
        let backpack = this.getData().backpack;
        return Object.keys(backpack).length > 0;
    }

    //判断是否可以进行买入
    checkCanBuy(){
        let objMap = getpawnShopObjMap();
        let backPack = this.getData().backpack;
        let canBuy:boolean = false;
        for(let key in objMap){
            let obj = backPack[key];
            if(obj != null){
                canBuy = true;
                break;
            }
        }
        return canBuy;
    }

    //获取背包中一个随机物品
    getBackpackRandObj(){
        let keys = Object.keys(this.getData().backpack);
        return this.getData().backpack[data_control.getRandItemOfArray(keys)];
    }

    //获取一个物品金钱影响倍率
    getOneObjMoneyMultiple(obj:pawnShopGameObjI){
        let multiple:number = 0;
        let quality = obj.quality;
        switch(quality){
            case pawnShopObjQualityE.blemish:{
                multiple = 5;
                break;
            }
            case pawnShopObjQualityE.intact:{
                multiple = 20;
                break;
            }
            default:{
                multiple = 1;
                break;
            }
        }
        return multiple;
    }
}
